import { render, staticRenderFns } from "./GameImporterOverview.vue?vue&type=template&id=98e9809c"
import script from "./GameImporterOverview.vue?vue&type=script&lang=js"
export * from "./GameImporterOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports